/* Selv Rituel · contenu des coffrets dans le panier (1er oct. 2026).
   Les listes <details class="selv-bundle" data-selv-bundle="<variante>"> sont ouvertes par défaut ; quand la cliente
   en replie une, elle le reste pendant la visite (sessionStorage), y compris quand le tiroir ou la page panier se
   redessine après une mise à jour. Les copies d'un même coffret (tiroir et page /cart) restent alignées. */
(() => {
  'use strict';
  if (window.SelvBundle) return;
  const d = document;
  const KEY = 'selv-bundle-closed';
  const SEL = 'details[data-selv-bundle]';
  const read = () => { try { return new Set(JSON.parse(sessionStorage.getItem(KEY) || '[]')); } catch (e) { return new Set(); } };
  const write = (s) => { try { sessionStorage.setItem(KEY, JSON.stringify(Array.from(s))); } catch (e) { /* sans effet : l'état reste en mémoire */ } };
  let closed = read();
  const apply = (root) => {
    const list = root.matches && root.matches(SEL) ? [root] : (root.querySelectorAll ? root.querySelectorAll(SEL) : []);
    list.forEach((el) => { const open = !closed.has(el.dataset.selvBundle); if (el.open !== open) el.open = open; });
  };
  // « toggle » ne remonte pas : écoute en phase de capture. Idempotent : un redessin qui réapplique l'état enregistré
  // ne change rien ; un vrai geste met à jour l'état et les autres copies du même coffret.
  d.addEventListener('toggle', (e) => {
    const el = e.target;
    if (!el || !el.matches || !el.matches(SEL)) return;
    const k = el.dataset.selvBundle;
    if (closed.has(k) === !el.open) return;
    if (el.open) closed.delete(k); else closed.add(k);
    write(closed);
    d.querySelectorAll(SEL).forEach((x) => { if (x !== el && x.dataset.selvBundle === k && x.open !== el.open) x.open = el.open; });
  }, true);
  const start = () => {
    apply(d);
    if (!('MutationObserver' in window)) return;
    // seules zones redessinées : le tiroir (zones dynamiques de Flow) et la page /cart (selv-cart-page.js)
    const mo = new MutationObserver((muts) => {
      if (!closed.size) return;
      muts.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) apply(n); }));
    });
    [d.getElementById('CartDrawer'), d.querySelector('[data-selv-cart-root]')].filter(Boolean)
      .forEach((r) => mo.observe(r, { childList: true, subtree: true }));
  };
  // retour arrière (cache de page) : relire l'état, qui a pu changer dans une autre page de la visite
  window.addEventListener('pageshow', (e) => { if (e.persisted) { closed = read(); apply(d); } });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  window.SelvBundle = { apply };
})();
